export const time = value => {
    let result = '';
    if (value) {
        result = `${value.substr(0, 4)}-${value.substr(5, 2)}-${value.substr(
            8,
            2
        )} ${value.substr(11, 2)}:${value.substr(14, 2)}:${value.substr(17, 2)}`;
    }
    return result;
};

export const statusFont = status => {
    const map = new Map([
        [1, '#iconeffective'],
        [2, '#iconexpired'],
        [3, '#iconrevoked'],
        [4, '#iconfrozen'],
        [5, '#iconyifoujue'],
        [6, '#icondaishenhe'],
        [7, '#iconyichang']
    ]);
    return map.get(status);
};


export const sealStatus = status => {
    const map = new Map([
        [1, '有效'],
        [2, '已过期'],
        [3, '已注销'],
        [4, '已冻结'],
        [5, '已否决'],
        [6, '待审核'],
        [7, '异常'],
    ]);
    return map.get(status) || '全部';
};